'use client';

import animationData from '@/animations/copilot.json';
import { FC } from 'react';
import LottieHandler from './LottieHandler';

export interface AnimationCopilotProps {
  playing?: boolean;
}

const AnimationCopilot: FC<AnimationCopilotProps> = ({ playing }) => {
  return (
    <div className="flex">
      <LottieHandler animationData={animationData} playing={playing} />
    </div>
  );
};

export default AnimationCopilot;
